import { ICON_FILL } from "utils/constant/STYLE";

export const convertSubjectEngName = (subject: string) => {
  switch (subject) {
    case "안정성":
      return "Stable";
    case "수익성":
      return "Profit";
    case "활동성":
      return "Active";
    case "현금흐름":
      return "Cash";
    case "현금흐름보상비율":
      return "Cash";
    case "영업현금흐름":
      return "Operating cash flow";
    case "단기차입금":
      return "Short-term borrowings";
    case "금융비용":
      return "Financial expenses";
    case "부채비율":
      return "Debt-to-equity ratio";
    case "부채총계":
      return "Total liabilities";
    case "자본총계":
      return "Total equity";
    case "재고자산회전율":
      return "Inventory turnover ratio";
    case "매출액":
      return "Revenue";
    case "재고자산":
      return "Inventory";
    case "총자산회전율":
      return "Total asset turnover ratio";
    case "자산총계":
      return "Total assets";
    case "유동자산회전율":
      return "Current asset turnover ratio";
    case "유동자산":
      return "Current assets";
    case "자산수익률":
      return "Return on assets";
    case "매출총이익률":
      return "Gross profit margin";
    case "매출총이익":
      return "Gross profit";
    case "총자산영업이익률":
      return "Return on total assets";
    case "3년간 영업현금흐름":
      return "Operating cash flow for 3 years";
    default:
      return subject;
  }
};

export const GoodIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M4 12.75C4 7.91751 7.91751 4 12.75 4H17.25C22.0825 4 26 7.91751 26 12.75V17.25C26 22.0825 22.0825 26 17.25 26H12.75C7.91751 26 4 22.0825 4 17.25V12.75Z"
        fill="#3E9EFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 18.5C16.933 18.5 18.5 16.933 18.5 15C18.5 13.067 16.933 11.5 15 11.5C13.067 11.5 11.5 13.067 11.5 15C11.5 16.933 13.067 18.5 15 18.5ZM15 21C18.3137 21 21 18.3137 21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15C9 18.3137 11.6863 21 15 21Z"
        fill="white"
      />
    </svg>
  );
};
export const BadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M24.3832 24.9999C25.5419 24.9999 26.2631 23.7421 25.6777 22.7422L16.033 6.26567C15.4466 5.26394 13.9935 5.27921 13.4283 6.29304L4.24279 22.7695C3.68539 23.7694 4.40824 24.9999 5.55295 24.9999H24.3832Z"
        fill="#FFBF5F"
      />
      <path
        d="M13.5242 12.6406C13.4303 11.7643 14.1171 11 14.9984 11C15.8798 11 16.5666 11.7643 16.4727 12.6406L15.9113 17.8797C15.8614 18.3462 15.4676 18.7 14.9984 18.7C14.5292 18.7 14.1355 18.3462 14.0856 17.8797L13.5242 12.6406Z"
        fill="#4F6272"
      />
      <path
        d="M13.8984 20.9C13.8984 20.2925 14.3909 19.8 14.9984 19.8C15.606 19.8 16.0984 20.2925 16.0984 20.9C16.0984 21.5075 15.606 22 14.9984 22C14.3909 22 13.8984 21.5075 13.8984 20.9Z"
        fill="#4F6272"
      />
    </svg>
  );
};

export const HelpIcon = ({ fill }: { fill?: any }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={fill ? ICON_FILL[fill] : ICON_FILL["gray40"]}
    >
      <path
        d="M7.06503 9.49199C7.07504 8.2215 7.43518 7.83135 8.06542 7.4412C8.49559 7.17109 8.81571 6.83096 8.81571 6.33076C8.81571 5.77055 8.38555 5.41041 7.83533 5.41041C7.33514 5.41041 6.85495 5.73053 6.82494 6.40079H5.57446C5.60447 5.06027 6.61486 4.37 7.84534 4.37C9.19586 4.37 10.1262 5.12029 10.1262 6.31076C10.1262 7.12107 9.71606 7.65128 9.06581 8.04143C8.48559 8.39157 8.24549 8.7417 8.23549 9.49199V9.58203H7.06503V9.49199ZM7.68528 11.7929C7.25511 11.7929 6.90497 11.4428 6.90497 11.0126C6.90497 10.5924 7.25511 10.2423 7.68528 10.2423C8.09544 10.2423 8.45557 10.5924 8.45557 11.0126C8.45557 11.4428 8.09544 11.7929 7.68528 11.7929Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 2.54562C4.98624 2.54562 2.54415 4.9877 2.54415 8.00016C2.54415 11.0126 4.98624 13.4547 7.9987 13.4547C11.0112 13.4547 13.4532 11.0126 13.4532 8.00016C13.4532 4.9877 11.0112 2.54562 7.9987 2.54562ZM1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HelpIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className="text-gray30"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337ZM8.77646 11.9198C8.79007 10.1909 9.28014 9.66 10.1378 9.12908C10.7231 8.76152 11.1588 8.29867 11.1588 7.61801C11.1588 6.85567 10.5734 6.3656 9.82467 6.3656C9.14401 6.3656 8.49058 6.80122 8.44974 7.7133H6.74809C6.78893 5.88913 8.16386 4.94982 9.83829 4.94982C11.6761 4.94982 12.9421 5.97081 12.9421 7.59079C12.9421 8.69346 12.384 9.41496 11.4991 9.94587C10.7095 10.4223 10.3828 10.8988 10.3692 11.9198V12.0423H8.77646V11.9198ZM9.62048 15.0508C9.03511 15.0508 8.55865 14.5744 8.55865 13.989C8.55865 13.4172 9.03511 12.9408 9.62048 12.9408C10.1786 12.9408 10.6687 13.4172 10.6687 13.989C10.6687 14.5744 10.1786 15.0508 9.62048 15.0508Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HelpGrayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={ICON_FILL["gray50"]}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00065 14.6663C11.6826 14.6663 14.6673 11.6816 14.6673 7.99968C14.6673 4.31778 11.6826 1.33301 8.00065 1.33301C4.31875 1.33301 1.33398 4.31778 1.33398 7.99968C1.33398 11.6816 4.31875 14.6663 8.00065 14.6663ZM7.02234 9.53525C7.03323 8.15214 7.42529 7.72741 8.11139 7.30268C8.57969 7.00863 8.92819 6.63835 8.92819 6.09382C8.92819 5.48395 8.45989 5.09189 7.86091 5.09189C7.31638 5.09189 6.79363 5.44039 6.76096 6.17006H5.39964C5.43231 4.71072 6.53226 3.95927 7.8718 3.95927C9.34203 3.95927 10.3549 4.77606 10.3549 6.07204C10.3549 6.95418 9.90834 7.53138 9.20045 7.95611C8.5688 8.33728 8.30743 8.71845 8.29653 9.53525V9.63326H7.02234V9.53525ZM7.69755 12.0401C7.22926 12.0401 6.84809 11.6589 6.84809 11.1906C6.84809 10.7332 7.22926 10.352 7.69755 10.352C8.14407 10.352 8.53613 10.7332 8.53613 11.1906C8.53613 11.6589 8.14407 12.0401 7.69755 12.0401Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RiskDepartureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <circle cx="5" cy="5" r="4.5" stroke="#F501F9" strokeDasharray="2 2" />
    </svg>
  );
};

export const MedalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" />
      <path
        d="M12.4235 9.05263L9.8972 4H5.26562L7.79194 9.05263H12.4235Z"
        fill="#FA4D56"
      />
      <path
        d="M11.5765 9.05263L14.1028 4H18.7344L16.2081 9.05263H11.5765Z"
        fill="#DA1E28"
      />
      <circle
        cx="12.0025"
        cy="13.2632"
        r="6.31579"
        fill="#FFCC00"
        stroke="#FFBB00"
        strokeWidth="0.842105"
      />
      <path
        d="M15.0506 11.733C14.8927 11.5288 14.6346 11.4858 14.5263 11.4858H11.7618L12.1831 9.59053C12.2143 9.46007 12.2034 9.33303 12.1504 9.20943C12.0973 9.08583 12.0115 8.9897 11.8929 8.92103C11.7743 8.85236 11.651 8.82833 11.5231 8.84893C11.3951 8.86953 11.2843 8.9279 11.1907 9.02403L9.48744 11.6013C8.43297 13.1908 8.5385 14.0827 8.98934 15.1084C9.43555 16.1237 10.7378 16.83 11.103 16.8418H14.0759C14.2195 16.8418 14.3481 16.796 14.4878 16.6976C14.6307 16.597 14.7125 16.4847 14.7687 16.3474C14.8249 16.2101 15.1232 14.7249 15.2523 13.7307C15.3533 12.9531 15.417 12.2068 15.0506 11.733Z"
        fill="#FFE58F"
      />
    </svg>
  );
};

export const DevilIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" />
      <path
        d="M6.85775 21.002C6.14749 21.002 5.57172 20.4262 5.57172 19.7159C5.57172 19.3101 5.2427 18.981 4.83684 18.981C4.12659 18.981 3.55081 18.4053 3.55081 17.695C3.55081 16.9848 4.12659 16.409 4.83684 16.409H6.06163C6.22064 16.409 6.37536 16.3574 6.50256 16.262L7.77634 15.3067L9.24609 16.7764L8.29076 18.0502C8.19535 18.1774 8.14378 18.3321 8.14378 18.4911V19.7159C8.14378 20.4262 7.568 21.002 6.85775 21.002Z"
        fill="#8194A7"
      />
      <path
        d="M16.9626 21.002C17.6728 21.002 18.2486 20.4262 18.2486 19.7159C18.2486 19.3101 18.5776 18.981 18.9835 18.981C19.6937 18.981 20.2695 18.4053 20.2695 17.695C20.2695 16.9848 19.6937 16.409 18.9835 16.409H17.7587C17.5997 16.409 17.445 16.3574 17.3178 16.262L16.044 15.3067L14.5742 16.7764L15.5296 18.0502C15.625 18.1774 15.6765 18.3321 15.6765 18.4911V19.7159C15.6765 20.4262 16.2523 21.002 16.9626 21.002Z"
        fill="#8194A7"
      />
      <path
        d="M17.693 2.99805C18.4033 2.99805 18.9791 3.57382 18.9791 4.28408C18.9791 4.68994 19.3081 5.01895 19.7139 5.01895C20.4242 5.01895 21 5.59473 21 6.30499C21 7.01524 20.4242 7.59102 19.7139 7.59102H18.4891C18.3301 7.59102 18.1754 7.64259 18.0482 7.73799L16.7744 8.69333L15.3047 7.22358L16.26 5.9498C16.3554 5.82259 16.407 5.66788 16.407 5.50887V4.28408C16.407 3.57382 16.9828 2.99805 17.693 2.99805Z"
        fill="#8194A7"
      />
      <path
        d="M6.30697 2.99805C5.59671 2.99805 5.02094 3.57382 5.02094 4.28408C5.02094 4.68994 4.69192 5.01895 4.28606 5.01895C3.57581 5.01895 3.00003 5.59473 3.00003 6.30499C3.00003 7.01524 3.57581 7.59102 4.28606 7.59102H5.51085C5.66986 7.59102 5.82457 7.64259 5.95178 7.73799L7.22556 8.69333L8.69531 7.22358L7.73998 5.9498C7.64457 5.82259 7.593 5.66788 7.593 5.50887V4.28408C7.593 3.57382 7.01722 2.99805 6.30697 2.99805Z"
        fill="#8194A7"
      />
      <path
        d="M15.3034 16.5127C17.0708 15.7353 18.2468 14.2364 18.2468 11.9994C18.2468 8.54956 15.4502 5.75293 12.0003 5.75293C8.55053 5.75293 5.75391 8.54956 5.75391 11.9994C5.75391 14.2331 6.92638 15.7308 8.68948 16.5092V16.7768C8.68948 17.5885 9.34751 18.2465 10.1592 18.2465H13.8336C14.6453 18.2465 15.3034 17.5885 15.3034 16.7768V16.5127Z"
        fill="#BDC7D1"
      />
      <rect
        x="8.19531"
        y="9.94141"
        width="2.96068"
        height="3.38363"
        rx="1.48034"
        fill="#262E36"
      />
      <rect
        x="12.8438"
        y="9.94141"
        width="2.96068"
        height="3.38363"
        rx="1.48034"
        fill="#262E36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9635 13.1357C12.0937 13.0055 12.3047 13.0055 12.4349 13.1357L13.1016 13.8024C13.1641 13.8649 13.1992 13.9497 13.1992 14.0381V14.3714C13.1992 14.4598 13.1641 14.5446 13.1016 14.6071L12.7683 14.9405C12.7057 15.003 12.621 15.0381 12.5326 15.0381H11.8659C11.7775 15.0381 11.6927 15.003 11.6302 14.9405L11.2968 14.6071C11.2343 14.5446 11.1992 14.4598 11.1992 14.3714V14.0381C11.1992 13.9497 11.2343 13.8649 11.2968 13.8024L11.9635 13.1357Z"
        fill="#262E36"
      />
    </svg>
  );
};

// YYYYMM -> YY년 N분기
export function convertToQuarter(date: string, router: any) {
  if (!date) return "";
  const year = date.slice(2, 4);
  const quarter = date.slice(4, 6);
  return router.locale === "ko"
    ? `${year}년 ${Number(quarter)}분기`
    : `Q${Number(quarter)} '${year}`;
}
